module.exports = __webpack_public_path__ + "static/media/flushed-face-svgrepo-com.109e6611.svg";